import React, { useEffect } from 'react';

import { getImagePaths, getMemoryText } from './memoryUtils';

import './ImageLightbox.css';

const ImageLightbox = ({ memory, onClose }) => {
  useEffect(() => {
    if (!memory) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') onClose();
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [memory, onClose]);

  if (!memory) return null;

  const imagePaths = getImagePaths(memory);
  const { primaryText, secondaryText } = getMemoryText(memory);
  const src = imagePaths.original || imagePaths.reduced || imagePaths.thumbnail;

  if (!src) return null;

  return (
    <div className="image-lightbox" role="dialog" aria-modal="true" onClick={onClose}>
      <button type="button" className="image-lightbox-close" onClick={onClose} aria-label="Zavřít">
        Zavřít
      </button>
      <figure className="image-lightbox-figure" onClick={(event) => event.stopPropagation()}>
        <img src={src} alt={secondaryText || primaryText || 'Fotografie vzpomínky'} />
        {(secondaryText || primaryText) && (
          <figcaption>
            {secondaryText && <strong>{secondaryText}</strong>}
            {primaryText && <span>{primaryText}</span>}
          </figcaption>
        )}
      </figure>
    </div>
  );
};

export default ImageLightbox;
